import 'antd/lib/tree/style';
import 'antd/lib/input/style';
import 'antd/lib/tooltip/style';
import 'antd/lib/spin/style';
import 'antd/lib/icon/style';

import '../VtxTree.less';